export const namespaced = true;

export const state = {
    faces: [],
    face: {},
    types: [],
    meta: null,
    page: 1,
    per_page: 25,
    loading: false,
}

export const mutations = {
    FETCH_FACES(state, faces) {
        state.faces = faces;
    },
    FETCH_FACE(state, face) {
        state.face = face;
    },
    FETCH_META(state, meta) {
        state.meta = meta;
    },
    ADD_FACE(state) { },
    SET_PAGE(state, page) {
        state.page = page;
    },
    SET_PER_PAGE(state, per_page) {
        state.per_page = per_page;
    },
    FACES_REMOVE(state) { },
    FACES_BLOCK(state) { },
}

export const actions = {

    async fetch({ commit, state, dispatch }) {
        try {
            const res = (await axios.get(`/api/admin/faces`, {
                params: {
                    page: state.page,
                    per_page: state.per_page
                }
            })).data;
            commit('FETCH_FACES', res.data);
            commit('FETCH_META', res.meta);
            return res.data;
        } catch (error) {
            const notification = {
                face: 'error',
                message: error.response && error.response.data && error.response.data.message
            }
            dispatch('notification/add', notification, { root: true })
        }
    },

    async fetchFace({ commit, state, dispatch }, face_id) {
        try {
            const res = (await axios.get(`/api/admin/faces/${face_id}`)).data;
            commit('FETCH_FACE', res.data.face);
            return res.data.face;
        } catch (error) {
            const notification = {
                face: 'error',
                message: error.response && error.response.data && error.response.data.message
            }
            dispatch('notification/add', notification, { root: true })
        }
    },

    async getGroups({ commit, dispatch }) {
        try {
            const res = (await axios.get(`/api/admin/faces-element-groups`)).data;
            return res;
        } catch (error) {
            const notification = {
                face: 'error',
                message: error.response && error.response.data && error.response.data.message
            }
            dispatch('notification/add', notification, { root: true })
        }
    },

    setPage({ commit, state, dispatch }, page) {
        commit('SET_PAGE', page);
        // dispatch('fetch');
    },

    setPerPage({ commit, state, dispatch }, per_page) {
        commit('SET_PAGE', 1);
        commit('SET_PER_PAGE', per_page);
        // dispatch('fetch');
    },

    async block({ commit, state, dispatch }, { deletes, status }) {
        if (deletes.length) {
            try {
                let formDataPost = new FormData();

                for (const i of deletes) {
                    formDataPost.append('blocked[]', i);
                }
                formDataPost.append('status', status);

                const res = (
                    await axios.post(
                        `/api/admin/block-faces`, formDataPost
                    )
                ).data;

                commit('FACES_BLOCK');

                dispatch('fetch');

                const notification = {
                    face: "success",
                    message: "Запрос успешно выполнен",
                };
                dispatch("notification/add", notification, { root: true });
            } catch (error) {
                const notification = {
                    face: 'error',
                    message: error.response && error.response.data && error.response.data.message
                }
                dispatch('notification/add', notification, { root: true });
                throw error;
            }
        } else {
            const notification = {
                face: 'error',
                message: 'Вы не выбрали ни одного типа'
            }
            dispatch('notification/add', notification, { root: true });
        }
    },

    async remove({ commit, state, dispatch }, deletes) {
        if (deletes.length) {
            try {
                let formDataPost = new FormData();

                for (const i of deletes) {
                    formDataPost.append('deletes[]', i);
                }

                const res = (
                    await axios.post(
                        `/api/admin/delete-faces`, formDataPost
                    )
                ).data;
                commit('FACES_REMOVE');

                dispatch('fetch');

                const notification = {
                    face: "success",
                    message: "Удаление прошло успешно",
                };
                dispatch("notification/add", notification, { root: true });
            } catch (error) {
                const notification = {
                    face: 'error',
                    message: error.response && error.response.data && error.response.data.message
                }
                dispatch('notification/add', notification, { root: true });
                throw error;
            }
        } else {
            const notification = {
                face: 'error',
                message: 'Вы не выбрали ни одного типа'
            }
            dispatch('notification/add', notification, { root: true });
        }
    },

}
